import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useMemo, useState } from 'react';
import { perm_details, requirements } from 'console/shared/device.acl/utils';
import { Box, IconButton, Typography } from '@mui/material';
import { MaterialBoolControl } from 'shared/components/fields';
import { HelpOutline } from '@mui/icons-material';
import { useHelpPopup } from 'shared/hooks/ui';
import { useBox } from 'shared/hooks/utils';
export const ACLPermissions = memo(function ACLPermissions(props) {
    const { value, show_gps, can_edit_settings, onChange } = props;
    const boxedValue = useBox(value);
    const onPermChanged = useCallback((perm) => () => {
        if (boxedValue.current.includes(perm)) {
            // checkmark removed
            const to_remove = [perm];
            for (let i = 0; i < to_remove.length; i++)
                for (const [key, reqs] of Object.entries(requirements))
                    if (reqs.includes(to_remove[i]))
                        to_remove.push(key);
            onChange(boxedValue.current.filter((perm) => !to_remove.includes(perm)));
        }
        else {
            // checkmark placed
            const to_add = [perm];
            for (let i = 0; i < to_add.length; i++)
                to_add.push(...(requirements[to_add[i]] ?? []));
            onChange([...new Set([...boxedValue.current, ...to_add])]);
        }
    }, [onChange]);
    const [tooltip, setTooltip] = useState(null);
    const [HelpPopup, openTooltip] = useHelpPopup();
    const onOpenTooltip = useCallback((perm) => (e) => {
        openTooltip(e);
        setTooltip(perm_details.get(perm)?.description ?? null);
    }, [openTooltip, setTooltip]);
    const components = useMemo(() => Array.from((function* getNeedPerm() {
        const _perms = new Map([...perm_details]
            .filter(([perm]) => perm !== 'view_gps' || show_gps)
            .filter(([, details]) => !details.hide_if_cannot_edit_settings ||
            can_edit_settings)).entries();
        for (const [perm, details] of _perms) {
            yield (_jsxs(Box, { display: "flex", children: [_jsx(MaterialBoolControl, { color: "primary", label: details.title, value: value.includes(perm), onChange: onPermChanged(perm), disabled: !can_edit_settings }), _jsx(IconButton, { size: "small", edge: "end", onClick: onOpenTooltip(perm), children: _jsx(HelpOutline, { fontSize: "small", color: "inherit" }) })] }, perm));
        }
    })()), [show_gps, can_edit_settings, onOpenTooltip, onPermChanged, value]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Typography, { variant: "h6", color: "textSecondary", children: "\u041F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u044F" }), components, _jsx(HelpPopup, { children: _jsx(Typography, { variant: "subtitle1", children: tooltip }) })] }));
});
